import React from 'react'
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <div>
        <footer className="main-footer padd-y">
        <div className="container">
          <div className="footer-content">
            <div className="row">
              <div className="col-md-3">
                <Link to="/">
                  <img src="/images/logo.svg" className="logo-img" alt="Logo" />
                </Link>
              </div>
              <div className="col-md-9">
                <div className="footer-links">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="row">
                        <div className="col-md-6">
                          <h4>Get fast, reliable print services on the go.</h4>
                          <h5>
                            Download Now for <br /> Android & iOS
                          </h5>
                        </div>
                        <div className="col-md-6">
                          <div className="joinus-link-btn">
                            <button className="btn btn-download">
                              <img
                                src="images/google-downloadimg.png"
                                alt="/"
                              />
                            </button>
                            <button className="btn btn-download">
                              <img src="images/ios-downloadimg.png" alt="/" />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <ul className="links">
                        <li>
                          <h5>Overview</h5>
                        </li>
                        <li>
                          <Link to="#">About</Link>
                        </li>
                        <li>
                          <Link to="#">Services</Link>
                        </li>
                        <li>
                          <Link to="#">How we works?</Link>
                        </li>
                      </ul>
                    </div>
                     <div className="col-md-3">
                      <ul className="links">
                        <li>
                          <h5>Support</h5>
                        </li>
                        <li>
                          <Link to="/privacy-policy">Privacy Policy</Link>
                        </li>
                        <li>
                          <Link to="/terms-condition">Terms & Condition</Link>
                        </li>
                        <li>
                          <Link to="/account-delete">Delete Account</Link>
                        </li>
                      </ul>
                    </div>
                    <div className="col-md-3 padd-y">
                      <ul className="links">
                        <li>
                          <h5>Connect</h5>
                        </li>
                        <li>
                          <Link to="#">
                            <img src="images/mail-icon.png" alt="/" />{" "}
                            support@glenssy.com
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            <img src="images/mobile-icon.png" alt="/" /> +1
                            56789 23456
                          </Link>
                        </li>
                        &nbsp;
                        <li className="d-flex aic">
                          <Link to="#">
                            <img src="images/f-icon.png" alt="/" />
                            &nbsp;
                          </Link>
                          <Link to="#">
                            <img src="images/twitter-icon.png" alt="/" />
                            &nbsp;
                          </Link>
                          <Link to="#">
                            <img src="images/linkdin-icon.png" alt="/" />
                            &nbsp;
                          </Link>
                          <Link to="#">
                            <img src="images/insta-icon.png" alt="/" />
                            &nbsp;
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  )
}
